module.exports = __webpack_public_path__ + "media/images/emblems/Breil_Brigels_wappen-42f513d0117a8959f9832b456f587f7b.svg";